import React, { useEffect, useState } from 'react'
import { Table } from 'antd'
import axios from 'axios'
import '../../AdminComponents/Dashboard.css'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { UpcomingEvents } from '../../../AllAPI/StudentAPI'

export default function STudentDashboard() {
  const navigate = useNavigate()
   const formDataFromStorage = JSON.parse(
    sessionStorage.getItem('studentData') || '{}',
  )
  const BranchId = formDataFromStorage.branch_id
  const BoardingYear = formDataFromStorage.year

  //---------------------------------Disabled back button-------------------------------
  useEffect(() => {
    // Push a dummy state
    window.history.pushState(null, null, window.location.href)

    const handlePopState = () => {
      // Push forward again
      window.history.pushState(null, null, window.location.href)
    }

    window.addEventListener('popstate', handlePopState)

    return () => {
      window.removeEventListener('popstate', handlePopState)
    }
  }, [])

  const [eventList, setEventList] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    fetchUpcomingEvents()
  }, [])

  const fetchUpcomingEvents = async () => {
    try {
      setLoading(true)

      const res = await axios.get(`${UpcomingEvents}/${BranchId}/${BoardingYear}`)
      setEventList(res.data || [])
    } catch (error) {
      toast.error('Failed to load upcoming events')
    } finally {
      setLoading(false)
    }
  }

  const eventColumns = [
    {
      title: 'Event',
      dataIndex: 'event_name',
      key: 'event_name',
      render: (text) => <strong>{text}</strong>,
    },
    {
      title: 'Date',
      dataIndex: 'event_date',
      key: 'event_date',
    },
    {
      title: 'Time',
      dataIndex: 'event_time',
      key: 'event_time',
    },

  ]

  const stats = [
    { label: 'ABCD', value: '0', gradient: 'grad-blue1' },
    { label: 'EFGH', value: '0', gradient: 'grad-green1' },
    { label: 'IJKL', value: '0', gradient: 'grad-orange1' },
    { label: 'MNOP', value: '0', gradient: 'grad-purple1' },
  ]

  return (
    <div className="dashboard-container">
      {/* Stat Boxes */}
      {/* <div className="row p-0 m-0 pb-5">
        <div className="col-12 col-md-1"></div>
        <div className="col-12 col-md-10 p-md-5">
          <div className="stats-grid">
            {stats.map((stat, index) => (
              <div className={`stat-card1 ${stat.gradient}`} key={index}>
                <h4>{stat.label}</h4>
                <p className="stat-number1">{stat.value}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="col-12 col-md-1"></div>
      </div> */}

      {/* Upcoming Events */}
      <div className="row m-0 py-5">
        <div className="col-12 col-md-3"></div>

        <div className="col-12 col-md-6">
          <div className="event-card">
            <h4 className="section-title">📅 Upcoming Events</h4>

            <Table
              loading={loading}
              columns={eventColumns}
              dataSource={eventList}
              rowKey="id"
              pagination={false}
              bordered={false}
            />
          </div>
        </div>

        <div className="col-12 col-md-3"></div>
      </div>

    </div>
  )
}
